import { PenLine, Quote } from "lucide-react";
import { Reveal } from "./Reveal";
import { PenMark } from "./BrandLogo";

export default function Author() {
  return (
    <section id="author" data-testid="author-section" className="relative py-20 sm:py-28">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <Reveal>
          <div
            data-testid="author-bio-card"
            className="grid grid-cols-1 items-stretch gap-0 overflow-hidden rounded-3xl border-2 border-ink bg-white shadow-pop-lg md:grid-cols-12"
          >
            <div className="halftone relative flex min-h-64 flex-col items-center justify-center gap-5 border-b-2 border-ink bg-maroon p-10 text-center md:col-span-5 md:border-b-0 md:border-r-2">
              <PenMark className="h-20 w-20 animate-floaty drop-shadow-[4px_4px_0_rgba(0,0,0,0.35)]" />
              <p className="font-mono text-xs font-bold uppercase tracking-[0.3em] text-banana">
                Storyteller · Author · Encourager
              </p>
              <blockquote className="max-w-xs font-display text-xl font-semibold italic leading-snug text-cream">
                <Quote className="mx-auto mb-2 h-5 w-5 text-banana" />
                You hold the pen. You are the author of your own story — no one can tell it like you can.
              </blockquote>
            </div>

            <div className="p-8 sm:p-12 md:col-span-7">
              <span className="sticker -rotate-1 rounded-lg bg-banana">
                <PenLine className="h-3.5 w-3.5" /> Meet the author
              </span>
              <h2 className="mt-5 font-head text-3xl font-extrabold tracking-tight sm:text-4xl">
                Corella Berry-Moten
              </h2>
              <p className="mt-1 font-display text-lg font-semibold text-maroon">affectionately known as “Sugarfoot”</p>
              <p className="mt-5 text-base leading-relaxed text-ink/75 sm:text-lg">
                Corella Berry-Moten is an author and storyteller with one message for every reader:{" "}
                <span className="font-bold text-royal">you hold the pen</span>. Her{" "}
                <span className="font-bold text-maroon">Believe in Yourself</span> children's series — which grows out
                of her memoir, <span className="font-display font-semibold">Corella, The Author of My Own Story</span>{" "}
                — reminds young readers that they are the authors of their own stories. They add their own chapters,
                they change their own endings, and no one can tell their story like they can.
              </p>
              <div className="mt-7 flex flex-wrap gap-3">
                {["Believe in Yourself", "You Got This!", "Kindness", "Healthy Living"].map((t, i) => (
                  <span
                    key={t}
                    className="rounded-full border-2 border-ink bg-cream px-4 py-1.5 font-mono text-xs font-bold uppercase tracking-widest shadow-pop-sm"
                    style={{ transform: `rotate(${i % 2 === 0 ? -1.5 : 1.5}deg)` }}
                  >
                    {t}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
